module.exports = __webpack_public_path__ + "media/playing_single_line_6.6c06370e.mp3";